<template>
	<div class="evModal">
		<div class="evModal__cont evModal__cont--flex">
			<!-- <div class="evModal__contFlex"> -->
			<CloseEventsHeroModal />
			<div class="evModal__calCont">
				<div class="evModal__topCont">
					<p class="evModal__title2" v-if="this.title">
						{{ title }}
					</p>
					<p class="evModal__otherDatesP">Other dates & times</p>
				</div>

				<div class="evModal__cal">
					<EventPicker
						class="homePicker__dp datePick"
						v-model="datePicked"
						:disabled-dates="this.vueDatepickerOptions[0]"
						model-type="yy-m-d"
						inline
						auto-apply
					></EventPicker>
				</div>
			</div>
			<div v-if="paginatedItems" class="evModal__matchingEvents">
				<div class="evModal__topCont evModal__topCont--events">
					<p class="evModal__matchingEventsP">
						Showing results for
						<span v-if="textForDate">{{ textForDate }}</span>
					</p>
				</div>
				<div
					:class="
						ropes
							? 'evModal__matchingEventsDiv evModal__matchingEventsDiv--ropes'
							: 'evModal__matchingEventsDiv'
					"
				>
					<div
						:class="
							ropes
								? 'evModal__matchEv evModal__matchEv--ropes'
								: 'evModal__matchEv'
						"
						v-for="(ev, index) in paginatedItems"
						:key="ev.id"
					>
						<p class="evModal__ropesHelper" v-if="ropes">Event time:</p>
						<!-- <p class="evModal__evTitle">{{ ev.title }}</p> -->
						<div
							:class="
								ropes
									? 'evModal__evTime evModal__evTime--ropes'
									: 'evModal__evTime'
							"
							v-html="ev.displayTime"
						></div>
						<!-- <button @click="openShowOtherTimes(index)"></button> -->
						<div class="evModal__ropesHelper" v-if="ropes">
							<p>$5 Extra with General Admission ticket</p>
							<span>&middot;</span>
							<p>$15 Standalone</p>
						</div>
						<div
							v-if="ropes"
							:class="
								ropes
									? 'buttons evModal__buttonDiv evModal__buttonDiv--ropes'
									: 'buttons evModal__buttonDiv'
							"
						>
							<a
								:href="`https://my.pem.org/components/sharedsession?actionUrl=https://pem.org/actions/my-module/default&returnUrl=https://pem.org/pemtickets?date=${ev.hyphenDate}%26type=ga`"
								class="evModal__buy evModal__buy--ropes"
								>Buy Ropes + General admission</a
							>
							<a
								:href="`https://my.pem.org/components/sharedsession?actionUrl=https://pem.org/actions/my-module/default&returnUrl=https://pem.org/pemtickets?date=${ev.hyphenDate}%26type=tour`"
								class="secBtn secBtn--red"
								>Buy standalone ticket</a
							>
						</div>
						<div v-if="!ropes" class="buttons evModal__buttonDiv">
							<!-- button for custom link for event -->
							<a
								class="evModal__buy"
								v-if="ev.customEventLink"
								:href="ev.customEventLink"
								>{{ ev.buttonText }}</a
							>
							<!-- button for /pemtickets -->
							<a
								:href="`https://my.pem.org/components/sharedsession?actionUrl=https://pem.org/actions/my-module/default&returnUrl=https://pem.org/pemtickets?id=${ev.tessId}`"
								v-if="ev.availableCount > 0"
								class="evModal__buy"
								>{{ ev.buttonText }}</a
							>
							<!-- button for /pemtickets but sold out -->
							<div
								class="evModal__buy evModal__buy--soldOut"
								v-if="ev.availableCount === 0"
							>
								Sold out
							</div>

							<div>
								<p
									@click="openLinks(index)"
									class="evModal__evButton secBtn secBtn--red addToCal"
								>
									Add to calendar
								</p>
								<transition name="date-transition">
									<div v-if="ev.open" class="evModal__links">
										<a tabindex="0" :href="ev.ics">Apple</a>
										<a tabindex="0" :href="ev.google">Google</a>
										<a tabindex="0" :href="ev.ics">Outlook</a>
									</div>
								</transition>
							</div>
						</div>
					</div>
				</div>
				<!-- pagination -->
				<div
					v-if="
						allMatchingEvents && allMatchingEvents.length > this.itemsPerPage
					"
					class="evModal__pagination"
				>
					<PaginateLeft
						class="evModal__pageButts"
						:currentPage="currentPage"
						@prevPage="prevPage"
					/>
					<span v-for="page in totalPages" :key="page" class="evModal__pageNum">
						<button
							@click="goToPage(page)"
							:class="{ active: currentPage === page }"
						>
							{{ page }}
						</button>
					</span>
					<PaginateRight
						class="evModal__pageButts"
						:currentPage="currentPage"
						:totalPages="totalPages"
						@nextPage="nextPage"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CloseEventsHeroModal from './svg/CloseEventsHeroModal';
import PaginateLeft from './svg/PaginateLeft';
import PaginateRight from './svg/PaginateRight';
import Datepicker from 'vuejs-datepicker';
export default {
	name: 'EventsHeroModal',
	props: {
		entryid: String,
		object: String,
		ropes: Boolean,
	},
	components: {
		CloseEventsHeroModal,
		EventPicker: Datepicker,
		PaginateLeft,
		PaginateRight,
	},
	data() {
		return {
			currentPage: 1,
			itemsPerPage: 8,
			datePicked: null,
			entryData: null,
			twigData: null,
			allMatchingEvents: null,
			matchingEvents: null,
			mergedData: null,
			statusData: null,
			textForDate: null,
			title: null,
			vueDatepickerOptions: [
				{
					to: new Date(),
					from: new Date(),
					dates: [],
				},
			],
		};
	},

	mounted() {
		this.getObject();
		this.getEventInfo();
		this.isRopes();
	},
	methods: {
		isRopes() {
			this.itemsPerPage = 2;
		},
		getEventInfo() {
			let that = this;
			$.get(
				'/api/v1/eventSearch',
				{
					entryid: that.entryid,
				},
				function (res) {
					that.entryData = [];
					let entryDataArray = [];

					res.data[0].dateMatrix.forEach((el) => {
						const eventDateTime = new Date(el.eventDateTime.date);
						let formattedDate = eventDateTime.toLocaleDateString('en-US', {
							month: '2-digit',
							day: '2-digit',
							year: 'numeric',
							timeZone: 'America/New_York', // Set to New York time
						});
						formattedDate.replace('/', '-');
						function formatToYYYYMMDD(date) {
							const year = date.getFullYear();
							const month = String(date.getMonth() + 1).padStart(2, '0');
							const day = String(date.getDate()).padStart(2, '0');
							return `${year}-${month}-${day}`;
						}
						let hyphenDate = formatToYYYYMMDD(eventDateTime);

						let datePickTime = new Date(el.eventDateTime.date);
						datePickTime.setHours(0, 0, 0, 0);
						let entryObject = {
							id: el.id,
							tessId: el.tessituraId,
							title: res.data[0].title,
							date: new Date(el.eventDateTime.date),
							dateTime: formattedDate,
							hyphenDate: hyphenDate,
							endDate: el.eventEndDate.date,
							open: false,
							datepickTime: datePickTime.getTime(),
							soldOut: el.soldOut,
							buttonText: el.buttonText.value,
							customEventLink: el.addALink,
							availableCount: null,
						};
						entryDataArray.push(entryObject);
					});
					that.entryData = entryDataArray;
					that.title = res.data[0].title;
				}
			);
		},
		getEventsFromDatePicked(date) {
			if (date === null || this.mergedData === null) {
				return;
			}
			if (typeof date === 'object') {
				date = new Date(date).getTime();
			}

			const matchingEvents = this.mergedData.filter(
				(event) => event.datepickTime === date
			);
			this.allMatchingEvents = matchingEvents;
			this.matchingEvents = matchingEvents.slice(0, 8);
		},
		getObject() {
			// 'object' is fed into vue as a prop, here we unpack and sort the array of objects so it can be merged
			this.twigData = JSON.parse(this.object);
		},
		getInvalidDates(startDate, endDate, dateArray) {
			let invalidDates = [];
			let currentDate = new Date(startDate);
			let end = new Date(endDate);

			// Convert dateArray to a Set of normalized dates (YYYY-MM-DD) for quick lookup
			let dateSet = new Set(
				dateArray.map((date) => new Date(date).toDateString()) // Normalize to date string format
			);

			while (currentDate <= end) {
				let formattedDate = currentDate.toDateString(); // Normalize format

				// If the date is missing, store it as an invalid date
				if (!dateSet.has(formattedDate)) {
					invalidDates.push(
						new Date(
							currentDate.getFullYear(),
							currentDate.getMonth(),
							currentDate.getDate()
						)
					);
				}

				currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
			}

			return invalidDates;
		},
		getTheCalendarPluginOptions(mergedArray) {
			// now sort the data by date
			let sortedArray = mergedArray.sort(
				(a, b) => new Date(a.date) - new Date(b.date)
			);

			// filter past dates out
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			let filteredArray = (mergedArray = sortedArray.filter((obj) => {
				const eventDate = new Date(obj.date);
				return eventDate >= today; // Keep only events that are today or in the future
			}));

			this.mergedData = filteredArray;

			// set the Datepicked on the Calendar
			let datePickTime = new Date(filteredArray[0].date);
			datePickTime.setHours(0, 0, 0, 0);
			this.datePicked = datePickTime.getTime();

			// find the valid dates for the calendar in order to find the invalid dates (this.getInvalidDates())
			let validDatesArray = [];
			let today2 = new Date();
			today2 = today.setDate(today.getDate() - 1);
			today2 = new Date(today);
			filteredArray.forEach((el) => {
				let elDate = new Date(el.date);
				if (elDate >= today) {
					validDatesArray.push(elDate);
				}
			});

			let startDate = new Date(filteredArray[0].date);
			let endDate = new Date(filteredArray[filteredArray.length - 1].date);

			// give the calendar an array of dates to block out
			this.vueDatepickerOptions[0].dates = this.getInvalidDates(
				startDate,
				endDate,
				validDatesArray
			);
			// set the Start Date of the Calendar
			startDate.setDate(startDate.getDate() - 1);
			this.vueDatepickerOptions[0].to = startDate;

			// set the End Date of the Calendar
			this.vueDatepickerOptions[0].from = endDate;
		},
		dateFormatting(timestamp) {
			const date = new Date(timestamp);

			const options = { month: 'long', day: 'numeric', year: 'numeric' };
			const formattedDate = date.toLocaleDateString('en-US', options);

			// Get the day with suffix
			const day = date.getDate();
			const suffix = (day) => {
				if (day > 3 && day < 21) return 'th'; // 21st is special
				return ['th', 'st', 'nd', 'rd'][day % 10] || 'th';
			};

			return `${formattedDate.replace(day, day + suffix(day))}`;
		},
		textForDates(timestamp) {
			if (timestamp === null || timestamp === undefined) {
				return;
			}

			// Convert timestamp to EST
			const date = new Date(timestamp);
			const estDate = new Intl.DateTimeFormat('en-US', {
				timeZone: 'America/New_York',
				month: 'long',
				day: 'numeric',
				year: 'numeric',
			}).format(date);

			// Get the day with suffix
			const day = new Date(timestamp).getUTCDate(); // Extract UTC day for consistency
			const suffix = (day) => {
				if (day > 3 && day < 21) return 'th'; // Handle special cases
				return ['th', 'st', 'nd', 'rd'][day % 10] || 'th';
			};

			this.textForDate = `${estDate.replace(day, day + suffix(day))}`;
		},
		closeAllLinks() {
			if (this.paginatedItems === null || this.paginatedItems === undefined) {
				return;
			}
			this.paginatedItems.forEach((ev) => {
				ev.open = false;
			});
			this.$forceUpdate();
		},
		openLinks(index) {
			if (index === null || index === undefined) {
				return;
			}
			// close all but index
			this.paginatedItems.forEach((ev, i) => {
				if (i !== index) {
					ev.open = false;
				}
			});
			// Toggle only the clicked one
			this.paginatedItems[index].open = !this.paginatedItems[index].open;

			// Force Vue to update in case reactivity is not triggering
			this.$forceUpdate();
		},
		nextPage() {
			if (this.currentPage < this.totalPages) {
				this.currentPage++;
			}
		},
		prevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
			}
		},
		goToPage(page) {
			this.currentPage = page;
		},
		scrollTop() {
			window.scrollTo({
				top: 100, // Scroll to 80px above the top (won't work, adjust with offset)
				behavior: 'smooth',
			});
		},
	},
	watch: {
		currentPage() {
			this.scrollTop();
		},
		async entryData(data) {
			if (!data || data.length === 0) {
				this.statusData = [];
				return;
			}
			let tessIds = data
				.filter((item) => item.tessId !== null)
				.map((item) => item.tessId)
				.join(',');

			if (!tessIds) {
				return (this.statusData = data);
			}

			try {
				let res = await $.get(
					'/actions/my-module/default/available-tickets-check',
					{ arrayOfIds: tessIds }
				);
				let parsedRes = JSON.parse(res);
				if (Array.isArray(parsedRes) && parsedRes.length > 2) {
					let performanceArray = parsedRes; // Now safely using parsed data

					let updatedData = data.map((tess) => {
						let matchingPerformance = performanceArray.find(
							(perf) => perf.PerformanceId === parseInt(tess.tessId)
						);
						if (matchingPerformance) {
							return {
								...tess,
								soldOut: matchingPerformance.AvailableCount === 0,
								availableCount: matchingPerformance.AvailableCount,
							};
						}
						return tess;
					});

					this.statusData = updatedData;
				} else {
					this.statusData = data;
				}
			} catch (error) {
				console.error('Error fetching or parsing data:', error);
			}
		},
		statusData() {
			if (this.statusData && this.twigData) {
				let entryData = this.statusData;
				let twigData = this.twigData;

				// merge twig and element api data
				let mergedArray = entryData.map((obj1) => {
					const matchingObj2 = twigData.find((obj2) => obj2.id === obj1.id);
					if (matchingObj2) {
						return {
							...obj1, // Spread properties from array1
							google: matchingObj2.google,
							ics: matchingObj2.ics,
							displayTime: matchingObj2.displayTime,
						};
					}
					return obj1; // If no match found, return original object
				});

				this.getTheCalendarPluginOptions(mergedArray);
			}
		},
		datePicked(date) {
			if (date === null || this.mapEvents === null) {
				return;
			}
			this.closeAllLinks();
			this.getEventsFromDatePicked(date);
			this.textForDates(date);
			this.currentPage = 1;
		},
	},
	computed: {
		totalPages() {
			if (
				this.allMatchingEvents === null ||
				this.allMatchingEvents === undefined
			) {
				return;
			}
			return Math.ceil(this.allMatchingEvents.length / this.itemsPerPage);
		},
		paginatedItems() {
			if (
				this.allMatchingEvents === null ||
				this.allMatchingEvents === undefined
			) {
				return;
			}
			const start = (this.currentPage - 1) * this.itemsPerPage;
			return this.allMatchingEvents.slice(start, start + this.itemsPerPage);
		},
	},
};
</script>
